export const BGTI = [
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "previousAdmin",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "newAdmin",
        "type": "address"
      }
    ],
    "name": "AdminChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "beacon",
        "type": "address"
      }
    ],
    "name": "BeaconUpgraded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "Upgraded",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "ctr",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "wallet",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "am",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "len",
        "type": "uint256"
      }
    ],
    "name": "AMTokens",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tid",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "Owner",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "URI",
            "type": "string"
          }
        ],
        "internalType": "struct BatchGetTokenInfo.tokenInfo[]",
        "name": "returnData",
        "type": "tuple[]"
      },
      {
        "internalType": "bool",
        "name": "moreTokens",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "ctr",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "len",
        "type": "uint256"
      }
    ],
    "name": "ByIndex",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tid",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "Owner",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "URI",
            "type": "string"
          }
        ],
        "internalType": "struct BatchGetTokenInfo.tokenInfo[]",
        "name": "returnData",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "ctr",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "len",
        "type": "uint256"
      }
    ],
    "name": "Sequential",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tid",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "Owner",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "URI",
            "type": "string"
          }
        ],
        "internalType": "struct BatchGetTokenInfo.tokenInfo[]",
        "name": "returnData",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "ctr",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "wallet",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "len",
        "type": "uint256"
      }
    ],
    "name": "SpecificTokens",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tid",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "Owner",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "URI",
            "type": "string"
          }
        ],
        "internalType": "struct BatchGetTokenInfo.tokenInfo[]",
        "name": "returnData",
        "type": "tuple[]"
      },
      {
        "internalType": "bool",
        "name": "moreTokens",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "proxiableUUID",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newImplementation",
        "type": "address"
      }
    ],
    "name": "upgradeTo",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newImplementation",
        "type": "address"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "upgradeToAndCall",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
]
